module.exports = __webpack_public_path__ + "static/media/V2_18.2456900c.png";